export function App() {
  return (
    <main className="page">
      <img className="logo" src="/logo.jpg" alt="Albuelis" />
    </main>
  );
}
